import { Award, Heart, Star, Users, BadgeCheck, IndianRupee } from "lucide-react";
import { useContent } from "../hooks/useContent";
import * as Icons from "lucide-react";
/* const reasons = [
  { icon: Award, title: "Experienced & Passionate Instructors" },
  { icon: Heart, title: "Friendly & Supportive Environment" },
  { icon: Star, title: "Regular Stage Shows" },
  { icon: Users, title: "Personalized Training" },
  { icon: IndianRupee, title: "Affordable Fees" },
  { icon: BadgeCheck, title: "Certificate Courses" },
]; */

const WhyChooseUs = () => {
	const { data: content, isLoading } = useContent();
	const hero = content?.hero;
	const courses = content?.courses;
	const whyChooseUs = content?.whyChooseUs;
	const contact = content?.contact;
	console.log("Content in WhyChooseUs:", whyChooseUs);
	return (
		<section className="py-24 px-4 bg-maroon-gradient">
			<div className="max-w-6xl mx-auto">
				<div className="text-center mb-16">
				<p className="text-gold-light font-heading text-lg tracking-widest uppercase mb-2">Our Promise</p>
				<h2 className="text-4xl md:text-5xl font-display font-bold text-gold-gradient mb-4">
					Why Choose Us
				</h2>
				<div className="w-24 h-1 bg-accent mx-auto rounded-full" />
				</div>

				<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
					{whyChooseUs && whyChooseUs.map((reason,i) => {
						const Icon = Icons[reason.icon];
						console.log("Icon for reason", reason.title, "is", reason.icon, "->", Icon);
						return(
							<div
								key={i}
								className="flex items-start gap-4 p-6 rounded-lg bg-cream/5 border border-gold/20 hover:border-gold/40 transition-colors duration-300"
							>
								<div className="w-12 h-12 shrink-0 rounded-full bg-accent/20 flex items-center justify-center">
								{
									Icon && <Icon className="w-6 h-6 text-gold" />
								}
								</div>
								<p className="text-cream/90 font-heading text-lg leading-snug pt-2">
									{reason.title}
								</p>
							</div>
						)
					})}
				</div>
			</div>
		</section>
	);
};

export default WhyChooseUs;
